module.exports = __webpack_public_path__ + "static/media/gr.be0d63c3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gr.svg
// module id = 834
// module chunks = 0